// src/features/merchantConfig/lib/errorMessages.js
//
// Map the OMS canonical error_code strings (MERCHANT_CONFIG_API_DOCS §6) into
// merchant-friendly headlines. The detail text comes from the server's
// `error_message`; this module just gives us a recognisable title.
//
// Everything routes through `humanizeErrorCode()` so the toolbar / error
// banners stay consistent, and adding a new code is a one-line edit.

const TITLES = {
  // 4xx — validation
  PARAMETER_VALUE_CANNOT_BE_EMPTY: "Nothing to save",
  PARAMETER_VALUE_CANNOT_BE_NULL: "Missing required value",
  VALUE_DOES_NOT_MATCH: "Invalid configuration key",
  INVALID_PARAMETER_VALUE: "Value not accepted",

  // 404 — provisioning
  RECORD_NOT_FOUND: "Configuration not set up",

  // Network / unknown
  UNKNOWN_ERROR: "Couldn't save changes",
  TOKEN_EXPIRED: "Your session has expired",
  INVALID_TOKEN: "Your session is invalid",
  CANCELLED: "Request cancelled",
};

/**
 * @param {string | undefined | null} code
 * @returns {string}
 */
export function humanizeErrorCode(code) {
  if (!code) return TITLES.UNKNOWN_ERROR;
  return TITLES[code] || TITLES.UNKNOWN_ERROR;
}

/**
 * Suggest a recovery action for a given error code. Returned strings are
 * meant for short inline copy ("Try again", "Contact support", etc.).
 *
 * @param {string | undefined | null} code
 * @returns {string}
 */
export function suggestRecovery(code) {
  switch (code) {
    case "RECORD_NOT_FOUND":
      return "Contact support to enable this configuration.";
    case "INVALID_PARAMETER_VALUE":
      return "Check the highlighted field — the value must match the expected type.";
    case "PARAMETER_VALUE_CANNOT_BE_EMPTY":
      return "Make at least one change before saving.";
    case "PARAMETER_VALUE_CANNOT_BE_NULL":
      return "Reload the page and try again.";
    case "VALUE_DOES_NOT_MATCH":
      return "Reload the page — the configuration key looks wrong.";
    case "TOKEN_EXPIRED":
    case "INVALID_TOKEN":
      return "Please sign in again.";
    default:
      return "Try again. If the problem persists, contact support.";
  }
}
